var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Promo'),_c('Scheme'),_c('Possibility'),_c('Advantages'),_c('Module'),_c('HowWork'),_c('Form'),_c('Client')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }